module.exports = __webpack_public_path__ + "static/media/lighting.59299c98.svg";